import { Component } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
  standalone: false
})
export class AddUserComponent {
    @Output() cancelAction = new EventEmitter<void>();
  

  reportingLevels = [
    { label: 'Level 1', value: 'L1' },
    { label: 'Level 2', value: 'L2' },
    { label: 'Level 3', value: 'L3' }
  ];

  reportingChannels = [
    { label: 'Email', value: 'EMAIL' },
    { label: 'SMS', value: 'SMS' },
    { label: 'Dashboard', value: 'DASHBOARD' }
  ];

  form = {
    general: {
      activeUser: true,
      superAdmin: false
    },
    access: {
      customersTab: true,
      licrm: false,
      domo: false,
      reportingLevel: null,
      reportingChannel: null
    },
    order: {
      complete: false,
      modify: false,
      salesperson: false,
      editCustomer: false,
      secureData: false,
      commercial: false
    },
    risk: {
      atd: false,
      ssn: false
    }
  };

  onCancel() {
    this.cancelAction.emit();
  }
}
